import { render } from "./TaskStatusTableComponent.vue?vue&type=template&id=2d3c31fa&scoped=true"
import script from "./TaskStatusTableComponent.vue?vue&type=script&lang=js"
export * from "./TaskStatusTableComponent.vue?vue&type=script&lang=js"

import "./TaskStatusTableComponent.vue?vue&type=style&index=0&id=2d3c31fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3c31fa"]])

export default __exports__